import { Icon } from 'components/elements';
import { css, styled } from 'styles';
import { StyledMenuButtonOptionListItemProps } from './types';

const disabledItemStyle = css`
  color: ${({ theme }) => theme.menuButton.item.disabled.color};

  svg {
    color: ${({ theme }) => theme.menuButton.item.disabled.color};
  }
`;

const enabledItemStyle = css`
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.menuButton.item.hover.background};
    color: ${({ theme }) => theme.menuButton.item.hover.color};
  }
`;

export const MenuButtonOptionList = styled.div`
  background-color: ${({ theme }) => theme.menuButton.background};
  border-radius: ${({ theme }) => theme.radius.tiny};
  border: thin solid ${({ theme }) => theme.menuButton.border};
  box-shadow: ${({ theme }) => theme.shadow.large};
  font-size: 0.9rem;
  font-weight: 400;
  max-width: 20rem;
  min-width: 12em;
  padding: ${({ theme }) => theme.spacing.absolute.small} 0;
  position: absolute;
  right: 0;
  top: calc(100% + ${({ theme }) => theme.spacing.absolute.tiny});
  user-select: none;
  z-index: 5;
`;

export const MenuButtonOptionListItem = styled.div<StyledMenuButtonOptionListItemProps>`
  align-items: center;
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing.absolute.smaller};
  grid-template-areas: 'icon text';
  grid-template-columns: 1.5em 1fr;
  line-height: 2.5em;
  min-width: 13em;
  padding: 0 ${({ theme }) => theme.spacing.absolute.smaller};
  transition: background-color ${({ theme }) => theme.transition.fast} ease-in-out,
    color ${({ theme }) => theme.transition.fast} ease-in-out;

  ${({ $disabled }) => !$disabled && enabledItemStyle};
  ${({ $disabled }) => $disabled && disabledItemStyle};
`;

export const MenuButtonOptionListItemIcon = styled(Icon)`
  color: ${({ theme }) => theme.typography.emphasis.medium};
  font-size: 1.5em;
  grid-area: icon;
`;

export const MenuButtonOptionListItemText = styled.div`
  grid-area: text;
  white-space: nowrap;
`;

export const MenuButtonOptionListSeparator = styled.div`
  border-bottom: thin solid ${({ theme }) => theme.menuButton.separator.color};
  margin: ${({ theme }) => theme.spacing.absolute.small} 0;

  &:first-child,
  &:last-child {
    display: none;
  }
`;

export const StyledMenuButton = styled.span`
  display: inline-block;
  position: relative;
`;

MenuButtonOptionList.displayName = 'MenuButtonOptionList';
MenuButtonOptionListItem.displayName = 'MenuButtonOptionListItem';
MenuButtonOptionListItemIcon.displayName = 'MenuButtonOptionListItemIcon';
MenuButtonOptionListItemText.displayName = 'MenuButtonOptionListItemText';
MenuButtonOptionListSeparator.displayName = 'MenuButtonOptionListSeparator';
StyledMenuButton.displayName = 'MenuButton.Styled';
